export default __webpack_public_path__ + "static/media/comment-many-o.ef299be7.svg";